module.exports = __webpack_public_path__ + "static/media/PracticeOptionBlue.9940229e.svg";